import React, { useMemo } from 'react';

import { Pie } from '@ant-design/plots';
import { Empty } from 'antd';

type Row = { status: string; count: number };

type Props = {
  rows: Row[];
};

/** Brand-aligned palette for Eureka status slices. */
const PALETTE = [
  '#1677ff',
  '#52c41a',
  '#fa8c16',
  '#eb2f96',
  '#722ed1',
  '#13c2c2',
  '#fadb14',
  '#a0d911',
  '#ff4d4f',
  '#8c8c8c',
];

export const EurekaStatusDonut = ({ rows }: Props) => {
  const data = useMemo(() => rows.filter((r) => r.count > 0), [rows]);

  const total = useMemo(() => data.reduce((acc, r) => acc + r.count, 0), [data]);

  if (!data.length) {
    return <Empty description="No returns in this period" />;
  }

  return (
    <Pie
      data={data}
      angleField="count"
      colorField="status"
      innerRadius={0.62}
      radius={0.9}
      autoFit
      height={300}
      scale={{ color: { range: PALETTE } }}
      legend={{
        color: {
          position: 'bottom',
          layout: { justifyContent: 'center' },
        },
      }}
      label={{
        text: (d: Row) => `${Math.round((d.count / total) * 100)}%`,
        position: 'outside',
        style: { fontWeight: 600, fontSize: 12 },
      }}
      tooltip={{
        title: 'status',
        items: [
          {
            field: 'count',
            valueFormatter: (v: number) => `${v} (${Math.round((v / total) * 100)}%)`,
          },
        ],
      }}
      annotations={[
        {
          type: 'text',
          style: {
            text: `${total}`,
            x: '50%',
            y: '46%',
            textAlign: 'center',
            fontSize: 28,
            fontWeight: 700,
            fill: '#262626',
          },
        },
        {
          type: 'text',
          style: {
            text: total > 1 ? 'returns' : 'return',
            x: '50%',
            y: '58%',
            textAlign: 'center',
            fontSize: 12,
            fill: '#8c8c8c',
          },
        },
      ]}
    />
  );
};
